import { defineComponent as _defineComponent } from 'vue'
import FullScreenLoader from 'JS/components/FullScreenLoader.vue';
import LoginSideMenuContents from 'JS/components/side-menus/account-creation/components/LoginSideMenuContents.vue';
import { CreateOauthAccountRequest, ICreateAccountResource, ICreateAccountResponse, LoginPageType } from 'JS/types/Account';
import { IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { onBeforeMount, ref } from 'vue';
import { provideServices } from 'JS/components/side-menus/composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'FullScreenLogin',
  props: {
	destinationUrl: {
		type: String,
		required: false,
		default: "/",
	}
},
  setup(__props) {

const props = __props

provideServices();



const currentPage = ref<LoginPageType>();
const isLoading = ref<boolean>(false);

const createAccountRequest = ref<ICreateAccountResource>(null);
const createAccountResponse = ref<ICreateAccountResponse>(null);
const createOauthAccountRequest = ref<CreateOauthAccountRequest>(null);

function handleSignedIn() {
	//Slightly delay redirect post login to give header time to refresh post login
	// (issues found previously with race conditions between header and redirect destinations)
	setTimeout(() => {
		window.location.href = props.destinationUrl;
	}, 500);
}

function handleGoToRewards(page: IJoinRewardsStep = "join", verificationData: IVerifyUserData = null, createData: ICreateAccountResource = null) {
	createOauthAccountRequest.value = null;
	createAccountRequest.value = createData;

	Blain.Rewards.showJoinRewardsSidePanel(page, false, true, props.destinationUrl, verificationData, createAccountRequest, createOauthAccountRequest);
	isLoading.value = false;
}

function handleGoToRewardsWithOauth(page: IJoinRewardsStep = "join", verificationData: IVerifyUserData = null, createOauth: CreateOauthAccountRequest = null) {
	createAccountRequest.value = null;
	createOauthAccountRequest.value = createOauth;

	Blain.Rewards.showJoinRewardsSidePanel(page, false, true, props.destinationUrl, verificationData, createAccountRequest, createOauthAccountRequest);
	isLoading.value = false;
}

onBeforeMount(()=> {
	const showCreate = new URLSearchParams(window.location.search).get('create') === '1';
	currentPage.value = showCreate ? 'create' : 'login';
});


return { __sfc: true,props, currentPage, isLoading, createAccountRequest, createAccountResponse, createOauthAccountRequest, handleSignedIn, handleGoToRewards, handleGoToRewardsWithOauth, FullScreenLoader, LoginSideMenuContents }
}

})